module.exports = __webpack_public_path__ + "static/UAmobSlide9-5119b07957dbf5d465fdc99dec5ea43f.jpg";